import styled from "@emotion/styled";
import SkapaSkeleton, { type SkeletonProps } from "@ingka/skeleton";

interface SkeletonStyleProps {
  width: string;
  height: string;
}

const SkeletonStyle = styled.div<SkeletonStyleProps>`
  ${(props) => (props.width ? `width: ${props.width}` : "")};
  ${(props) => (props.height ? `height: ${props.height}` : "")};
`;

interface Props {
  numberOfRows: number;
  width: string;
  height: string;
}

export const Skeleton = (props: SkeletonProps) => {
  return <SkapaSkeleton prefix="saleslead__" {...props} />;
};

export const DynamicSkeletonRows = ({ numberOfRows, height, width }: Props) => {
  const renderSkeletonRows = () => {
    const rows = [];
    for (let i = 0; i < numberOfRows; i++) {
      const key = `skeleton_row_${i}`;
      rows.push(
        <SkeletonStyle key={key} height={height} width={width}>
          <Skeleton />
        </SkeletonStyle>
      );
    }
    return rows;
  };
  return <div>{renderSkeletonRows()}</div>;
};
